// extracted by mini-css-extract-plugin
module.exports = {"description":"styles___description___2L1m7","selection-section":"styles___selection-section___3DPpV"};